<template>
  <div class="flex flex-col border-r border-transparent h-full">
    <AppTableHeader :headers="['Händelser']" />
    <ul
      style="width: 390px; min-width: 390px"
      class="border-r border-gray-20 flex-grow-1 h-full overflow-y-auto p-2 "
      :style="{ maxHeight: '100%', maxWidth: 'calc(100vw - 390px)' }"
    >
      <TimetableSplitViewEventListItem
        v-for="(event, $i) in events"
        :key="$i"
        :event="event"
      />
    </ul>
  </div>
</template>

<script>
import TimetableSplitViewEventListItem from './TimetableSplitViewEventListItem'
import { get } from 'vuex-pathify'

export default {
  name: 'TimetableEventList',

  components: {
    TimetableSplitViewEventListItem
  },

  computed: {
    date: get('timetable/selectedDateCell'),

    events: get('trainChange/allList')
  }
}
</script>
